module.exports = __webpack_public_path__ + "img/laurence.6f5843c2.jpg";